import {type StateTree} from 'pinia';
import {ToastType} from "~/components/Common/Toast/model/ToastType";

export interface ToastStoreStateOption {
    toastType: ToastType;
    contents: string;
    close?: {
        event: () => void;
    };
}

export interface ToastStoreState extends StateTree {
    show: boolean;
    options: ToastStoreStateOption;
}

export const state = (): ToastStoreState => ({
    show: false,
    options: {
        toastType: ToastType.SUCCESS,
        contents: ''
    }
});
